export const USER_MESSAGE = "USER_MESSAGE";
export const BOT_MESSAGE = "BOT_MESSAGE";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";

export const SHOW_QUICK_REPLY_CONTAINER = "SHOW_QUICK_REPLY_CONTAINER";
export const HIDE_QUICK_REPLY_CONTAINER = "HIDE_QUICK_REPLY_CONTAINER";
export const OPEN_CONTAINER = "OPEN_CONTAINER";
export const CLOSE_CONTAINER = "CLOSE_CONTAINER";
